import React, { useState } from "react";

function Login() {

    const [message, setMessage] = useState("");

    const [form, setForm] = useState({
        email: "",
        password: ""
    });

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const res = await fetch("http://localhost:5000/api/login", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(form)
            });

            const data = await res.json();

            if (res.ok) {

                // sacuvaj token
                localStorage.setItem("token", data.token);

                setMessage("Uspešno ste prijavljeni");

                // redirect admin panel
                window.location.href = "/Jodust-panel";

            } else {
                setMessage(data.message);
            }

        } catch (err) {
            console.error(err);
            setMessage("Greška na serveru.");
        }
    };

    return (
        <main>

            {/* HERO */}
            <section
                className="text-white text-center py-5"
                style={{ backgroundColor: "#1f4068" }}
            >
                <div className="container py-4">
                    <h1 className="fw-bold">Admin prijava</h1>
                    <p className="lead">
                        Prijavite se da biste upravljali sadržajem sajta
                    </p>
                </div>
            </section>

            {/* LOGIN FORM */}
            <section className="py-5 bg-light">
                <div className="container">

                    <div className="row justify-content-center">

                        <div className="col-md-5">

                            <div className="card shadow-sm p-4">

                                <h3 className="text-center fw-bold mb-4">
                                    Prijava
                                </h3>

                                <form onSubmit={handleSubmit}>

                                    {/* EMAIL */}
                                    <div className="mb-3">
                                        <label className="form-label">Email</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            name="email"
                                            placeholder="Unesite email"
                                            value={form.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    {/* PASSWORD */}
                                    <div className="mb-3">
                                        <label className="form-label">Lozinka</label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            name="password"
                                            placeholder="Unesite lozinku"
                                            value={form.password}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    {/* BUTTON */}
                                    <button
                                        type="submit"
                                        className="btn btn-warning w-100 mt-3"
                                    >
                                        Prijavi se
                                    </button>
                                    {message && (
                                        <div className="mt-3 text-center" style={{ color: "red", fontWeight: "bold" }}>
                                            {message}
                                        </div>
                                    )}
                                </form>

                            </div>

                        </div>

                    </div>

                </div>
            </section>

        </main>
    );
}

export default Login;